import React, { useEffect, useState } from 'react';
import {
    applyAnalyticsConsent,
    getStoredConsent,
    saveConsent,
    OPEN_COOKIE_SETTINGS_EVENT,
} from '../utils/cookieConsent';
import './CookieBanner.css';

function CookieBanner() {
    const [isVisible, setIsVisible] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const [analytics, setAnalytics] = useState(false);

    useEffect(() => {
        const consent = getStoredConsent();
        if (consent) {
            applyAnalyticsConsent(Boolean(consent.analytics));
        } else {
            setIsVisible(true);
        }

        const openSettings = () => {
            const current = getStoredConsent();
            setAnalytics(Boolean(current && current.analytics));
            setShowSettings(true);
            setIsVisible(true);
        };
        window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, openSettings);
        return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, openSettings);
    }, []);

    const close = () => {
        setIsVisible(false);
        setShowSettings(false);
    };

    const handleAccept = () => {
        saveConsent({ analytics: true, choice: 'accepted_all' });
        close();
    };

    const handleReject = () => {
        saveConsent({ analytics: false, choice: 'rejected_all' });
        close();
    };

    const handleSave = () => {
        saveConsent({ analytics, choice: 'custom' });
        close();
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-banner" role="dialog" aria-modal="false" aria-labelledby="cookie-banner-title">
            <div className="cookie-banner-inner">
                <h2 id="cookie-banner-title" className="cookie-banner-title">Respectăm alegerea dumneavoastră</h2>
                <p className="cookie-banner-text">
                    Folosim cookie-uri strict necesare pentru funcționarea site-ului. Cu acordul dumneavoastră,
                    folosim și cookie-uri de analiză (Google Analytics), pentru statistici. Puteți accepta, refuza
                    sau alege pe categorii. Detalii în{' '}
                    <a href="/politica-de-cookies">Politica de cookie-uri</a>.
                </p>

                {showSettings && (
                    <div className="cookie-settings">
                        <div className="cookie-category">
                            <div>
                                <strong>Strict necesare</strong>
                                <p>Autentificarea și memorarea acestei alegeri. Nu pot fi dezactivate.</p>
                            </div>
                            <input type="checkbox" checked disabled aria-label="Strict necesare (activ permanent)" />
                        </div>
                        <div className="cookie-category">
                            <div>
                                <strong>Analiză</strong>
                                <p>Google Analytics, pentru statistici anonime despre utilizarea site-ului.</p>
                            </div>
                            <input
                                type="checkbox"
                                checked={analytics}
                                onChange={(e) => setAnalytics(e.target.checked)}
                                aria-label="Cookie-uri de analiză"
                            />
                        </div>
                        <button type="button" className="cookie-btn" onClick={handleSave}>
                            Salvează alegerea
                        </button>
                    </div>
                )}

                {!showSettings && (
                    <div className="cookie-actions">
                        <button type="button" className="cookie-btn" onClick={handleAccept}>Accept</button>
                        <button type="button" className="cookie-btn" onClick={handleReject}>Refuz</button>
                        <button type="button" className="cookie-btn" onClick={() => setShowSettings(true)}>Setări</button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default CookieBanner;
